import { render, staticRenderFns } from "./TrainingTopicFormModal.vue?vue&type=template&id=40464380"
import script from "./TrainingTopicFormModal.vue?vue&type=script&lang=js"
export * from "./TrainingTopicFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports